import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { PersonalUserViewModel } from '../types/personal-user';
import { apiClient } from '../client/client';
import { buildPaginationParams } from '../client/queryParams';

/**
 * GET /api/personal-user – list personal (non-corporate) users for admin.
 * Backend should implement this endpoint with pagination; response shape same as corporate list.
 */
export interface PersonalUserQuery {
  pagination?: { pageSize?: number; pageNumber?: number } | null;
}

export class PersonalUserService {
  private static readonly BASE = '/api/personal-user';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(query?: PersonalUserQuery): Promise<ServiceResultT<PersonalUserViewModel[]>> {
    const params = buildPaginationParams(query?.pagination ?? { pageSize: 20, pageNumber: 1 });
    const { data } = await this.client.get<ServiceResultT<PersonalUserViewModel[]>>(
      PersonalUserService.BASE,
      { params }
    );
    return data;
  }
}

export const personalUserService = new PersonalUserService();
